module.exports = __webpack_public_path__ + "static/img/bg-en.f4e3c0ba.png";